import * as React from 'react';
import './style.scss';

const TitleBar = props => {
  return (
    <div className="title-bar">
      <div className="container">
        <h1>{props.title}</h1>
      </div>
    </div>
  );
};

export default TitleBar;
